import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorsComponent } from '@app/core/errors/errors-component/errors.component';

const routes: Routes = [
  {
    path: 'error',
    component: ErrorsComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class ErrorRoutingModule { }
